import { jwtDecode, JwtPayload } from "jwt-decode";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingSpinner from "../../../components/essentials/loading-spin/LoadingSpinner";
import AuthApiRoutes from "../../../shared/api-routes/auth/auth.api-routes";
import http from "../../../shared/utils/http";

/// TODO: refactor graphic
const EmailVerification: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const enum states {
    VERIFYING = "VERIFYING",
    INVALID_TOKEN = "INVALID_TOKEN",
    EMAIL_ALREADY_VALID = "EMAIL_ALREADY_VALID",
    REDIRECTING = "REDIRECTING",
  }
  const [state, setState] = useState<states>(states.VERIFYING);
  const [email, setEmail] = useState<string>();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      const tokenPayload: JwtPayload & { email: string } = jwtDecode(token);
      console.log("token:", tokenPayload.email);
      const currentTime = Math.floor(Date.now() / 1000);
      if (tokenPayload.exp && tokenPayload.exp > currentTime) {
        http
          .get(AuthApiRoutes.VALIDATE_MAIL(token))
          .then((passwordToken) => {
            setState(states.REDIRECTING);
            navigate("/sign-up/password?token=" + passwordToken);
          })
          .catch((err) => {
            if (err.status === 409) {
              setState(states.EMAIL_ALREADY_VALID);
            } else onTokenInvalid(tokenPayload.email);
          });
      } else {
        onTokenInvalid(tokenPayload.email);
      }
    }
  }, []);

  const onTokenInvalid = (tokenEmail: string) => {
    console.log(tokenEmail);
    http
      .post(AuthApiRoutes.RESEND_VERIFICATION_MAIL, { email: tokenEmail })
      .then(() => {
        setEmail(tokenEmail);
        setState(states.INVALID_TOKEN);
      });
  };

  const setMessage = () => {
    switch (state) {
      case states.VERIFYING:
        return (
          <div
            style={{
              color: "white",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <p>We're verifying your email, please wait</p>
            <LoadingSpinner />
          </div>
        );
      case states.INVALID_TOKEN:
        return (
          <div
            style={{ color: "white", textAlign: "center", fontSize: "20px" }}
          >
            <p>This verification link is expired or invalid</p>
            <p>
              Another link has been sent to <b>{email}</b>
            </p>
            <p>Check your inbox</p>
          </div>
        );
      case states.EMAIL_ALREADY_VALID:
        return (
          <div
            style={{ color: "white", textAlign: "center", fontSize: "20px" }}
          >
            <p>
              Your email has already been verified, but you have to set your
              password
            </p>
            <p>
              A link has been sent to <b>{email}</b>
            </p>
            <p>Check your inbox</p>
          </div>
        );
      case states.REDIRECTING:
        return (
          <div
            style={{
              color: "white",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <p>
              Your email has been verifying, redirecting you to password
              setup...
            </p>
            <LoadingSpinner />
          </div>
        );
    }
  };
  return <>{setMessage()}</>;
};

export default EmailVerification;
